(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details-tabs"] && !Shopify.designMode) return;
  try {
    
/* ============================================================
   SHIPPING DATA — deliveryDays = total business days from
   order date (processing + transit), matching dilevia.com
   ============================================================ */
var PDS_SHIPPING_DATA = {
  US: { standard: { deliveryDays: 10 }, express: { deliveryDays: 7 } },
  CA: { standard: { deliveryDays: 11 }, express: { deliveryDays: 7 } },
  UK: { standard: { deliveryDays: 9 },  express: { deliveryDays: 7 } },
  DE: { standard: { deliveryDays: 10 }, express: { deliveryDays: 7 } },
  FR: { standard: { deliveryDays: 10 }, express: { deliveryDays: 7 } },
  IT: { standard: { deliveryDays: 11 }, express: { deliveryDays: 7 } },
  ES: { standard: { deliveryDays: 11 }, express: { deliveryDays: 7 } },
  NL: { standard: { deliveryDays: 10 }, express: { deliveryDays: 7 } },
  BE: { standard: { deliveryDays: 10 }, express: { deliveryDays: 7 } },
  SE: { standard: { deliveryDays: 12 }, express: { deliveryDays: 8 } },
  DK: { standard: { deliveryDays: 12 }, express: { deliveryDays: 8 } },
  NO: { standard: { deliveryDays: 13 }, express: { deliveryDays: 8 } },
  CH: { standard: { deliveryDays: 12 }, express: { deliveryDays: 8 } },
  AU: { standard: { deliveryDays: 13 }, express: { deliveryDays: 8 } },
  NZ: { standard: { deliveryDays: 14 }, express: { deliveryDays: 8 } },
  SG: { standard: { deliveryDays: 9 },  express: { deliveryDays: 7 } },
  JP: { standard: { deliveryDays: 9 },  express: { deliveryDays: 7 } },
  KR: { standard: { deliveryDays: 9 },  express: { deliveryDays: 7 } }
};
/* ---- Date helpers (matching dilevia.com logic) ---- */
function pdsAddBusinessDays(date, days) {
  var result = new Date(date.getTime());
  var count = 0;
  while (count < days) {
    result.setDate(result.getDate() + 1);
    var day = result.getDay();
    if (day !== 0 && day !== 6) {
      count++;
    }
  }
  return result;
}
function pdsAddCalendarDays(date, days) {
  var result = new Date(date.getTime());
  result.setDate(result.getDate() + days);
  return result;
}
/* Format: "Tue, Sep 22" */
function pdsFormatDate(date) {
  var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return days[date.getDay()] + ', ' + months[date.getMonth()] + ' ' + date.getDate();
}
function pdsCalculateETA(countryCode, method) {
  var country = PDS_SHIPPING_DATA[countryCode] || PDS_SHIPPING_DATA['US'];
  var plan = country[method] || country.standard;
  var today = new Date();
  var startDate = pdsAddBusinessDays(today, plan.deliveryDays);
  var endDate = pdsAddCalendarDays(startDate, 2);
  return 'Get it by  ' + pdsFormatDate(startDate) + ' – ' + pdsFormatDate(endDate);
}
function pdsUpdateDates(sectionEl) {
  var select = sectionEl.querySelector('.pds-country-select');
  var countryCode = select ? select.value : 'US';
  sectionEl.querySelectorAll('.pds-eta').forEach(function (cell) {
    var method = cell.getAttribute('data-method');
    cell.textContent = pdsCalculateETA(countryCode, method);
  });
}
/* ============================================================
   INIT per section instance
   ============================================================ */
function pdsInitSection(section) {
  /* ===== Desktop tab switching ===== */
  var tabBtns = section.querySelectorAll('.pds-tab-btn');
  var panels = section.querySelectorAll('.pds-panel');
  /* DOM element id carries the "shopify-section-" prefix, but panel ids (from {{ section.id }}) do not */
  var bareId = section.id.replace('shopify-section-', '');
  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-tab');
      tabBtns.forEach(function (b) {
        b.classList.remove('active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      panels.forEach(function (p) { p.classList.remove('active'); });
      var targetPanel = section.querySelector('#panel-' + target + '-' + bareId);
      if (targetPanel) targetPanel.classList.add('active');
    });
  });
  /* ===== Mobile accordion ===== */
  var headers = section.querySelectorAll('.pds-accordion-header');
  headers.forEach(function (header) {
    header.addEventListener('click', function () {
      var item = header.parentElement;
      var isOpen = item.classList.contains('open');
      section.querySelectorAll('.pds-accordion-item').forEach(function (i) {
        i.classList.remove('open');
        i.querySelector('.pds-accordion-header').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('open');
        header.setAttribute('aria-expanded', 'true');
      }
    });
  });
  /* ===== Dynamic ETA: initial + country change ===== */
  pdsUpdateDates(section);
  section.querySelectorAll('.pds-country-select').forEach(function (select) {
    select.addEventListener('change', function () {
      /* Sync both desktop & mobile selects within this section */
      var val = select.value;
      section.querySelectorAll('.pds-country-select').forEach(function (s) {
        s.value = val;
      });
      pdsUpdateDates(section);
    });
  });
}
document.querySelectorAll('.section-product-details-tabs').forEach(pdsInitSection);
/* Re-init when the theme editor re-renders this section */
document.addEventListener('shopify:section:load', function (e) {
  var section = e.target;
  if (section && section.classList && section.classList.contains('section-product-details-tabs')) {
    pdsInitSection(section);
  }
});

  } catch(e) { console.error(e); }
})();
})();
